export default __webpack_public_path__ + "static/media/menu-toggle.8d08165b.png";